// import { useParams } from "react-router-dom";
// import { useEffect, useState } from "react";

// export default function DynamicAltImage() {
//   const { slug } = useParams();
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const imagePath = isMobile
//     ? `/${slug}-mobile.png`
//     : `/${slug}-desktop.png`;

//   return (
//     <div style={{ textAlign: "center"}}>
//       <img
//         src={imagePath}
//         alt={slug}
//         style={{
//           maxWidth: "100%",
//           height: "auto",
//           display: "block",
//           margin: "auto",
//         }}
//         onError={(e) => {
//           e.currentTarget.style.display = "none";
//           console.warn("Resim bulunamadı:", imagePath);
//         }}
//       />
//     </div>
//   );
// }
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function DynamicAltImage() {
  const { slug } = useParams();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [fallback, setFallback] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const defaultImage = isMobile
    ? "/images/9.webp"
    : "/images/slider1.png";

  const imagePath = fallback
    ? defaultImage
    : `/${slug}-${isMobile ? "mobile" : "desktop"}.png`;

  return (
    <div style={{ textAlign: "center" }}>
      <img
        src={imagePath}
        alt={slug}
        style={{
          maxWidth: "100%",
          height: "auto",
          display: "block",
          margin: "auto",
        }}
        onError={() => {
          if (!fallback) {
            setFallback(true); // Fallback'a geçiş yap
            console.warn("Resim bulunamadı, yedeğe geçiliyor:", imagePath);
          }
        }}
      />
    </div>
  );
}
